<template>

  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <posts-table>
          </posts-table>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
  import PostsTable from './PostModules/ArchiveModules/Archives.vue'

export default {
    components: {
      PostsTable
    },
    data: function () {
      return {
        navigation: true
      }
    },
    methods: {
  
    }
  }
</script>
<style>
#new-post{
  background-color:rgba(255,255,255,.9);
}
.fas {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Archives.vue